<p>2025-Present</p>
<p>A hostless, stream of consciousness walking companion. Listen on 
    <a href="https://podcasts.apple.com/us/podcast/walk-talk/id1806625912" target="_blank">Apple</a>, 
    <a href="https://open.spotify.com/show/3akl5hzhTqZ6Od7yDiEIYg?si=77ded6f0d0ce467c" target="_blank">Spotify</a>
    , or wherever you get your podcasts</p>
<app-project-gallery [galleryItems]="galleryItems"></app-project-gallery>